import { render, staticRenderFns } from "./ClassificationChart.vue?vue&type=template&id=29cf2bb5&"
import script from "./ClassificationChart.vue?vue&type=script&lang=js&"
export * from "./ClassificationChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports